import React from 'react';
import { Head } from '@inertiajs/react';
import { Card } from '../../components/ui/card';

interface InviteSuccessProps {
  inviteName: string;
  name: string;
}

const InviteSuccess: React.FC<InviteSuccessProps> = ({
  inviteName

}) => {
  return (
    <div className="min-h-screen w-full bg-background">
      <Head title="Profile Completed Successfully" />

      <div className="container mx-auto px-4 py-8 md:py-16 max-w-2xl">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-foreground mb-2">
            Profile Completed Successfully!
          </h1>
          {inviteName && (
            <p className="text-muted-foreground">
              Invitation for {inviteName}
            </p>
          )}
        </div>

        {/* Success Card */}
        <Card className="p-8 md:p-12">
          <div className="flex flex-col items-center text-center space-y-6">
            {/* Success Icon */}
            <div className="w-20 h-20 rounded-full bg-green-100 dark:bg-green-900/20 flex items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-10 h-10 text-green-600 dark:text-green-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>

            {/* Success Message */}
            <div className="space-y-4">
              <p className="text-lg text-foreground">
                Your profile has been created successfully.
              </p>
              <p className="text-muted-foreground">
                The creator will be in touch with you soon to provide more information.
              </p>
            </div>

          </div>
        </Card>

 
      </div>
    </div>
  );
};

export default InviteSuccess;
